import React, { useState } from 'react';
import { Edit, PasswordInput, SimpleForm, TextInput, useNotify, BooleanInput, ImageInput, ImageField } from 'react-admin';
import { passwordValidator } from "./helperFunctions";
import { FormControlLabel, Switch, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    twoFactorSwitch: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    }
}));

// Add formatPic helper for image input
function formatPic(value) {
    if (!value || typeof value === "string") {
        return { src: value };
    } else {
        return value;
    }
}

export const ProfileEdit = ({ staticContext, ...props }) => {
    const classes = useStyles();
    const notify = useNotify();
    const [twoFactorEnabled, setTwoFactorEnabled] = useState(() => {
        // Initialize from localStorage
        return JSON.parse(localStorage.getItem('requiresTwoFactor') || 'false');
    });

    const handleTwoFactorToggle = async (event) => {
        const enabled = event.target.checked;
        try {
            const response = await fetch(`${localStorage.getItem('domain')}/api/users/${enabled ? 'enable' : 'disable'}-2fa`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json',
                    'X-COMPANY': localStorage.getItem('company') || 'ROOT',
                    'Bypass-Tunnel-Reminder': 'true'
                }
            });

            if (response.ok) {
                const data = await response.json();
                setTwoFactorEnabled(enabled);
                // Update localStorage when the status changes
                localStorage.setItem('requiresTwoFactor', JSON.stringify(enabled));
                notify(data.message, 'info');
            } else {
                const error = await response.json();
                notify(error.message || 'Failed to update two-factor authentication', 'error');
            }
        } catch (error) {
            notify('Failed to update two-factor authentication', 'error');
        }
    };

    // No need to fetch 2FA status on mount since we're using localStorage
    // and it's being kept in sync with the server state through the toggle handler

    return (
        <Edit
            id="me"
            resource="users"
            basePath="/my-profile"
            title="My profile"
            redirect='/'
            {...props}
        >
            <SimpleForm redirect='/'>
                <TextInput source="firstName"/>
                <TextInput source="lastName"/>
                <TextInput type="email" source="email"/>
                <TextInput type="email" source="email2" label="Secondary Email for Getting Copy of slips"/>

                <ImageInput format={formatPic} source="signatureImage" label="Signature Image" accept="image/*" placeholder={<p>Drop your file here</p>}>
                    <ImageField source="src" title="title" />
                </ImageInput>

                <ImageInput format={formatPic} source="profilePicture" label="Profile Picture" accept="image/*" placeholder={<p>Drop your file here</p>}>
                    <ImageField source="src" title="title" />
                </ImageInput>

                <PasswordInput label='Current Password' source="password.oldPassword" validate={passwordValidator}/>
                <PasswordInput label='New Password' source="password.newPassword" validate={passwordValidator}/>
                <FormControlLabel
                    className={classes.twoFactorSwitch}
                    control={
                        <Switch
                            checked={twoFactorEnabled}
                            onChange={handleTwoFactorToggle}
                            color="primary"
                        />
                    }
                    label="Enable Two-Factor Authentication"
                />
            </SimpleForm>
        </Edit>
    );
};
